$(document).ready(function () {
    function updateHeaderClass() {
        var $sections = $('section');
        var scrollTop = $(window).scrollTop();
        var triggerPoint = scrollTop + 0; // px from the top of the viewport

        $sections.each(function () {
            var $section = $(this);
            var offsetTop = $section.offset().top;
            var sectionHeight = $section.outerHeight();

            if (triggerPoint >= offsetTop && triggerPoint < offsetTop + sectionHeight) {
                // js-dark-nav section -> .dark (dark header text/logo, see
                // components/_header.scss); anything else -> .light, the
                // default light text/logo.
                if ($section.hasClass('js-dark-nav')) {
                    $('.js-header').removeClass('light').addClass('dark');
                } else {
                    $('.js-header').removeClass('dark').addClass('light');
                }
                return false; // Break the loop once a match is found
            }
        });
    }

    // Call updateHeaderClass when the document is ready
    updateHeaderClass();

    // Call updateHeaderClass on scroll or resize if content changes dynamically
    $(window).on('scroll resize', function () {
        updateHeaderClass();
    });
});
